import React, { CSSProperties } from 'react';
import styled from 'styled-components';
import {CONSTS} from './_constants';

type colTyped = {
    title: string,
    dataIndex: string
    align?: CSSProperties,
    render?: Function
}
type tableCounterSettingsType = {
    dataIndex?: string,
    title?: string
}
type tablePropsType = {
    columns?: colTyped[],
    dataSource?:[],
    counterSettings?: tableCounterSettingsType
    className?: string,
}

const Table = (props:  tablePropsType) => {
    const {columns, dataSource, counterSettings ,className} = props;

    return(
        <table className={className}>
            <thead>
                <tr>
                    {counterSettings && <td>{counterSettings.title}</td>}
                    {columns && columns.map((col, key) => <td key={key}>{col.title}</td> )}
                </tr>
            </thead>
            <tbody>
                {dataSource && dataSource.map((record, i) => (
                    <tr key={i}>
                        {counterSettings && <td>{i+1}</td>}
                        {columns && 
                            columns.map((col, key) => {
                                return (
                                    <td key={key}>{col.render ? col.render(record[col.dataIndex]) : record[col.dataIndex]}</td>
                                )
                            })
                        }
                        
                    </tr>
                ))}
            </tbody>
        </table>
    )
}

const StyledTable = styled(Table)`
    width: 100%;
    border-collapse: separate;
    border-spacing: 0 10px;
    > thead{
        font-size: 15px;
        color: rgba(211, 212, 218, 1);
        > tr{
            
            > td{
                padding-top:5px;
                padding-bottom: 5px;
                &:first-child{
                    padding-left: 20px;
                }
            }
        }
    }
    > tbody{
        color: rgba(77, 76, 101, 1);
        font-size: 14px;
        > tr{
            border: 1px solid red;
            > td{
                padding: 10px 0;
                line-height: 30px;
                border: 1px solid rgba(215, 219, 228, 1);
                &:not(:first-child){
                    border-left: none;
                }
                &:not(:last-child){
                    border-right: none;
                }
                &:first-child{
                    padding-left: 20px;
                    border-radius: ${CONSTS.border.radius2} 0 0 ${CONSTS.border.radius2};
                }
                &:last-child{
                    padding-right: 20px;
                    border-radius: 0 ${CONSTS.border.radius2} ${CONSTS.border.radius2} 0;
                }
            }
        }
    }
`

export default StyledTable;